import { Box, Flex, Text, useDisclosure } from "@chakra-ui/core";
import React from "react";
// import { Link } from 'react-router-dom';
import Search from "../../../Components/Search";
import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";
import "./Poster.scss";

function Poster() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box id="home" p={{ lg: 20, md: 10, sm: 5 }} className="poster">
      <div className="poster-container">
        <Flex
          justify="space-between"
          align="center"
          color="white"
          direction="column"
          padding="1em"
        >
          <Text fontSize="4xl" fontWeight="700">
            You cannot find the job, select the job you like from the job
          </Text>
          <Text fontSize="xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt,
            deserunt! Lorem ipsum dolor sit amet consectetur, adipisicing elit.
            Molestiae, eum?
          </Text>
        </Flex>
        {/* <Grid gap="0.5em" alignItems="flex-end" templateColumns="repeat(auto-fit, minmax(130px, 1fr))"> */}
        <Search onClickModal={onOpen} />
        <AdvancedSearch onOpen={onOpen} onClose={onClose} isOpen={isOpen} />
        {/* <Stack>
                        <Link to="/account/profile">Get Started</Link>
                        <Link style={{ color: "white"}} to="/auth">SignUP</Link>
                    </Stack> */}
        {/* </Grid> */}
      </div>
    </Box>
  );
}

export default Poster;
